module.exports = __webpack_public_path__ + "static/media/discover_icon.4f689497.svg";